<template>
  <div class="detailBox">
    <ul class="detailContent">
      <el-form
        :model="state.model"
        label-width="100px"
        :scroll-to-error="true"
        ref="formDom"
        style="position: relative"
      >
        <el-form-item
          label="是否启用"
          prop="IsQy"
        >
          <el-switch
            v-model="state.model.IsQy"
            inline-prompt
            active-text="启用"
            inactive-text="停用"
          />
        </el-form-item>
        <el-form-item
          label="封面图"
          prop="Fm"
          :rules="[{ required: true, message: '请上传封面图', trigger: 'change' }]"
        >
          <div style="display: flex; align-items: flex-end; gap: 16px">
            <el-upload
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="onChangeFile"
              accept="image/*"
            >
              <template #default>
                <el-button type="primary" icon="UploadFilled">
                  选择图片
                </el-button>
              </template>
            </el-upload>
            <el-image
              v-if="state.model.Fm"
              :src="$http.defaults.baseURL + state.model.Fm"
              style="width: 200px; height: 100px"
              fit="cover"
              :preview-src-list="[$http.defaults.baseURL + state.model.Fm]"
              preview-teleported
            />
          </div>
        </el-form-item>
        <el-form-item label="Banner类型" prop="Lx">
          <el-radio-group v-model="state.model.Lx">
            <el-radio :label="0">主Banner（带文字层）</el-radio>
            <el-radio :label="1">普通Banner</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标题" prop="Bt">
          <el-input
            v-model="state.model.Bt"
            placeholder="主Banner必填，如：皖美福地 醉美肥西"
          />
        </el-form-item>
        <el-form-item label="副标题" prop="Fbt">
          <el-input
            v-model="state.model.Fbt"
            placeholder="如：寻趣三河"
          />
        </el-form-item>
        <el-form-item label="跳转地址" prop="Djdz">
          <el-input
            v-model="state.model.Djdz"
            placeholder="小程序页面路径，如：/pages/product-detail/index?id=101"
          />
          <div style="color: #999; font-size: 12px; margin-top: 4px">
            小程序页面路径，例如 /pages/product-detail/index?id=101
          </div>
        </el-form-item>
        <el-form-item label="排序号" prop="Xh">
          <el-input-number
            v-model="state.model.Xh"
            :min="0"
            :max="9999"
            placeholder="数字越小越靠前"
          />
        </el-form-item>
      </el-form>
    </ul>
    <ul class="detailBtn">
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, reactive, ref } from "vue";
import {
  homelunbo_detail,
  homelunbo_add,
  homelunbo_edit,
  fujian_add,
} from "@/http/api";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const formDom = ref(null);
    const state = reactive({
      model: {
        IsQy: true,
        Lx: 1,
        Xh: 0,
      },
    });

    onMounted(() => {
      if (props.id) {
        homelunbo_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data;
          }
        });
      }
    });

    // 上传图片
    const onChangeFile = (file) => {
      let formData = new FormData();
      formData.append("file", file.raw);
      fujian_add(formData).then((res) => {
        if (res.status == 200) {
          // 附件返回 FuJian 对象，图片地址在 Dz 字段，如 /file/2025-01-01/xxx.jpg
          state.model.Fm = res.data?.Dz || res.data?.dz || res.data;
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (!valid) return false;

        if (props.id) {
          homelunbo_edit(props.id, state.model).then((res) => {
            proxy.$post_response(res, emit);
          });
        } else {
          homelunbo_add(state.model).then((res) => {
            proxy.$post_response(res, emit);
          });
        }
      });
    };

    return {
      state,
      formDom,
      onSubmit,
      onChangeFile,
    };
  },
};
</script>

<style scoped lang="less">
</style>
